/**
 * Resolves a tenant-owned brand image against the configured asset endpoint.
 * @param objectPath Stored absolute URL or uploaded object path
 */
export const resolvePortalBrandImage = (objectPath?: string | null) => {
  if (!objectPath) return "";
  if (/^https?:\/\//i.test(objectPath)) return objectPath;

  const baseUrl = import.meta.env.VITE_ASSETS_ENDPOINT || window.location.origin;
  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const normalizedPath = objectPath.replace(/^\/+/, "");

  try {
    const parsedBase = new URL(normalizedBase);
    const baseSegments = parsedBase.pathname.split("/").filter(Boolean);
    const pathSegments = normalizedPath.split("/").filter(Boolean);

    if (baseSegments.length && pathSegments.length && baseSegments.at(-1) === pathSegments[0]) {
      pathSegments.shift();
    }

    parsedBase.pathname =
      `${baseSegments.length ? `/${baseSegments.join("/")}` : ""}/${pathSegments.join("/")}`.replace(/\/+/g, "/");
    return parsedBase.toString();
  } catch {
    return `${normalizedBase}/${normalizedPath}`.replace(/([^:]\/)\/+/g, "$1");
  }
};

/**
 * Returns a compact monogram for tenant and user identity fallbacks.
 * @param name Display name
 */
export const getPortalInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase() || "P";
